class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.el = this;
    this.display = this.querySelector('[data-time-display]');
    this.block = this.closest('.countdown__block--timer, .countdown-blocks');

    this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
    this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
    this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
    this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
    this.messagePlaceholder = this.querySelector('[data-message-placeholder]');

    this.hideTimerOnComplete = this.el.dataset.hideTimer;
    this.completeMessage = this.el.dataset.completeMessage;
    this.targetTime = this.el.dataset.targetTime;

    this.timerComplete = false;
    this.interval = null;

    this.init();
  }

  init() {
    this._calculate();

    this.interval = setInterval(() => {
      if (!this.timerComplete) {
        this._calculate();
      }
    }, 1000);
  }

  _getTargetTime() {
    if (this.targetTime) {
      return new Date(this.targetTime).getTime();
    }

    /*
      Fallback only.
      This keeps the timer from breaking if older markup is still used,
      but this fallback uses the visitor's local timezone.
    */
    const year = this.el.dataset.year;
    const month = this.el.dataset.month;
    const day = this.el.dataset.day;
    const hour = this.el.dataset.hour || '00';
    const minute = this.el.dataset.minute || '00';

    if (!year || !month || !day) {
      return null;
    }

    return new Date(`${month}/${day}/${year} ${hour}:${minute}:00`).getTime();
  }

  _calculate() {
    const targetTime = this._getTargetTime();

    if (!targetTime || Number.isNaN(targetTime)) {
      return;
    }

    const timeDifference = targetTime - Date.now();

    if (timeDifference > 0) {
      const intervals = {
        days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((timeDifference / (1000 * 60)) % 60),
        seconds: Math.floor((timeDifference / 1000) % 60),
      };

      if (this.daysPlaceholder) {
        this.daysPlaceholder.innerHTML = intervals.days;
      }

      if (this.hoursPlaceholder) {
        this.hoursPlaceholder.innerHTML = intervals.hours;
      }

      if (this.minutesPlaceholder) {
        this.minutesPlaceholder.innerHTML = intervals.minutes;
      }

      if (this.secondsPlaceholder) {
        this.secondsPlaceholder.innerHTML = intervals.seconds;
      }

      if (this.display) {
        this.display.classList.add('countdown__display--loaded');
      }
    } else {
      this._completeTimer();
    }
  }

  _completeTimer() {
    if (this.timerComplete) return;

    if (this.daysPlaceholder) {
      this.daysPlaceholder.innerHTML = '0';
    }

    if (this.hoursPlaceholder) {
      this.hoursPlaceholder.innerHTML = '0';
    }

    if (this.minutesPlaceholder) {
      this.minutesPlaceholder.innerHTML = '0';
    }

    if (this.secondsPlaceholder) {
      this.secondsPlaceholder.innerHTML = '0';
    }

    if (this.completeMessage && this.messagePlaceholder) {
      this.messagePlaceholder.classList.add('countdown__timer-message--visible');
    }

    if (this.hideTimerOnComplete === 'true' && this.display) {
      this.display.classList.remove('countdown__display--visible');
      this.display.classList.add('countdown__display--hidden');
    }

    if (!this.completeMessage && this.hideTimerOnComplete === 'true' && this.block) {
      this.block.classList.add('countdown__block--hidden');
    }

    this.timerComplete = true;

    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}